import script from "./Head.vue?vue&type=script&setup=true&lang=js"
export * from "./Head.vue?vue&type=script&setup=true&lang=js"

import "./Head.vue?vue&type=style&index=0&id=719bd082&lang=scss&scoped=true"
script.__scopeId = "data-v-719bd082"

export default script